<template>
    <div class="flex flex-col items-center gap-8">
        <div
            class="gradient-mask relative flex max-w-fit gap-2 transition duration-500 ease-out">
            <div
                v-for="item in 40"
                :key="item"
                class="h-14 min-w-[8px] overflow-hidden rounded-full">
                <div
                    class="flex h-full w-full origin-bottom rounded-t-full transition duration-300 will-change-transform"
                    :class="[
                        item % 7 ? (item % 3 ? 'translate-y-8' : 'translate-y-4') : '',
                        'bg-slate-300',
                        'motion-safe:animate-[pulse_1.3s_infinite]',
                    ]"
                    :style="
                        item % 7
                            ? item % 5
                                ? 'animation-delay: 0s'
                                : 'animation-delay: .2s'
                            : 'animation-delay: .4s'
                    "
                />
            </div>
        </div>
        <div v-if="props.withText" class="text-lg font-semibold text-slate-400">Loading</div>
    </div>
</template>

<script setup>
const props = defineProps({
    withText: {
        type: Boolean,
        default: true,
    },
});
</script>

<style scoped>
.gradient-mask {
    -webkit-mask-image: linear-gradient(
        to right,
        transparent,
        black 20%,
        black 80%,
        transparent
    );
    mask-image: linear-gradient(
        to right,
        transparent,
        black 20%,
        black 80%,
        transparent
    );
}
</style>
